function goToStep(stepNumber) {
  const steps = document.querySelectorAll(".mdl-stepper-step");
  const contents = document.querySelectorAll(".step-content");
  steps.forEach((step, index) => {
    step.classList.remove("active-step");
    if (index < stepNumber - 1) {
      step.classList.add("step-done");
    } else {
      step.classList.remove("step-done");
    }
  });

  const targetStep = document.getElementById(`nf-step${stepNumber}`);
  targetStep.classList.add("active-step");

  contents.forEach((content) => (content.style.display = "none"));
  document.getElementById(`contentStep${stepNumber}`).style.display = "block";
}

function goToLogin() {
  document.getElementById("loginForm").style.display = "block";
  document.getElementById("signupForm").style.display = "none";
}

function goToSignin() {
  document.getElementById("loginForm").style.display = "none";
  document.getElementById("signupForm").style.display = "block";
}

function goToForm() {
  document.getElementById("contentStep2").style.display = "none";
  document.getElementById("contentStep3").style.display = "block";
}

function hasAccount(hasAccount) {
  document.getElementById("contentStep1").style.display = "none";
  document.getElementById("contentStep2").style.display = "block";
  if (hasAccount) {
    goToLogin();
  } else {
    goToSignin();
  }
  goToStep(2);
}
